import type { GTM } from "../../../../legacy/services/gtmEvent/GTMInterfaces";
import { sendGTMEvent } from "../../../../legacy/services/gtmEvents";

export function trackSuggestedPromptEvent(eventName: string, promptIdentifier: string) {
  const eventData: GTM.Event = {
    event: eventName,
    url: window.location.href,
    prompt: promptIdentifier,
  };

  sendGTMEvent(eventData);
}
